import React from "react";
import './FilterConfirmation.css'
export default function FilterConfirmation(props) {
  const { mainText1, mainText1Data, mainText2, mainText2Data } = props;

  return (
    <div style={{fontFamily:"VoltePlay-Medium"}}>
      <div
        className="confirmationContainer"
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <span className="packs-img">{localStorage.getItem("userName").toString()?.substr(1,2)}</span>{" "}
        <span
          className="confirmation-text"
          style={{
            maxWidth: "97%",
            display: "flex",
            flexDirection: "column",
            paddingBottom: "-10%",
          }}
        >
          {mainText1 && mainText1Data.length!==0 ? (
            <div>
              <h4 style={{ fontWeight: "600" }}>{mainText1}</h4>
              <div className="messageDataContainer">
              {mainText1Data.length !== 0 ? mainText1Data.map((oneData) => (
                
                <p>{oneData}</p>
             
              )) : <p>None</p>} </div>
            </div>
          ) : null}
          {mainText2 && mainText2Data.length!==0 ? (
            <div>
              <h4 style={{ fontWeight: "600" }}>{mainText2}</h4>
              <div className="messageDataContainer">
              {mainText2Data.map((oneData) => (
                
                <p>{oneData}</p>
             
              ))} </div>
            </div>
          ) : null}
        </span>
      </div>
    </div>
  );
}
